const cache = new Map<string, string>();

export function parseUserAgent(ua: string): string {
  const cached = cache.get(ua);
  if (cached !== undefined) return cached;

  const browser = parseBrowser(ua);
  const os = parseOS(ua);
  const result = [browser, os].filter(Boolean).join(' · ') || ua;

  cache.set(ua, result);
  return result;
}

function parseBrowser(ua: string): string {
  // Order matters — check specific browsers before generic ones
  if (/Edg\//u.test(ua)) return `Edge ${version(ua, /Edg\/([\d.]+)/u)}`;
  if (/OPR\//u.test(ua)) return `Opera ${version(ua, /OPR\/([\d.]+)/u)}`;
  if (/SamsungBrowser\//u.test(ua)) return `Samsung ${version(ua, /SamsungBrowser\/([\d.]+)/u)}`;
  if (/Brave/u.test(ua)) return 'Brave';
  if (/Vivaldi\//u.test(ua)) return `Vivaldi ${version(ua, /Vivaldi\/([\d.]+)/u)}`;
  if (/Firefox\//u.test(ua)) return `Firefox ${version(ua, /Firefox\/([\d.]+)/u)}`;
  if (/CriOS\//u.test(ua)) return `Chrome ${version(ua, /CriOS\/([\d.]+)/u)}`;
  if (/Chrome\//u.test(ua)) return `Chrome ${version(ua, /Chrome\/([\d.]+)/u)}`;
  if (/Safari\//u.test(ua) && /Version\//u.test(ua))
    return `Safari ${version(ua, /Version\/([\d.]+)/u)}`;
  return '';
}

function parseOS(ua: string): string {
  if (/iPhone|iPad|iPod/u.test(ua)) return `iOS ${version(ua, /OS ([\d_]+)/u).replace(/_/gu, '.')}`;
  if (/Android/u.test(ua)) return `Android ${version(ua, /Android ([\d.]+)/u)}`;
  if (/Mac OS X/u.test(ua))
    return `macOS ${version(ua, /Mac OS X ([\d_.]+)/u).replace(/_/gu, '.')}`;
  if (/Windows NT 10/u.test(ua)) return 'Windows 10+';
  if (/Windows NT/u.test(ua)) return 'Windows';
  if (/Linux/u.test(ua)) return 'Linux';
  if (/CrOS/u.test(ua)) return 'ChromeOS';
  return '';
}

function version(ua: string, regex: RegExp): string {
  const match = regex.exec(ua);
  if (!match?.[1]) return '';
  // Keep only major.minor
  const parts = match[1].split('.');
  return parts.slice(0, 2).join('.');
}
